// extracted by mini-css-extract-plugin
export default {"container":"ClientMap_container__YbBeK","title":"ClientMap_title__3lCB1","summary":"ClientMap_summary__C8EF8","layout":"ClientMap_layout__MF6ex","map":"ClientMap_map__1r6og"};